export default {
  spendField: 'thirty_day_spend',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 100,
      field: 'adpi',
      label: 'Ad Effect Score',
      format: '.0f',
      scale: [80, 160]
    },
    {
      metric: 101,
      field: 'recall',
      label: 'Branded Recall',
      format: '.0%',
      hasSpendData: true,
      scale: [0, 1.0]
    },
    {
      metric: 102,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 1.0]

    },
    {
      metric: 103,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 1.0]
    },
    {
      metric: 104,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%', 
      scale: [0, 1.0]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMB/config/components/scorecard/Trendchart/index.js